import { Conductor, Dynamic } from "../../../controllers/conductor";
import { ProgressIcon } from "../../widgets/loading";

/**
 * 
 * @param {{ controller: AlertDrawerController }} param0 
 * @returns 
 */
export function AlertDrawer({ controller }) {
    const conductor = controller.conductor;
    return <Dynamic conductor={conductor} child={()=>{
        const { active, status, message, retry, title } = controller;

        return <div className={`alert-drawer ${status} ${active ? "active" : ""}`}>
            <div className="left">{ status === "progress" ? <ProgressIcon /> : "" }</div>
            <div className="center">{title ? <b>{title}: </b> : ""}{message}</div>
            <div className="right">
                { retry ? <button className="retry-btn" onClick={retry}>RETRY</button> : []}
                <button onClick={() => controller.close()} className="close-btn" />
            </div>
        </div>;
    }}/>;
}

export class AlertDrawerController {
    constructor() {
        this.conductor = new Conductor();
        this.active = false;
        this.status = "";
        this.message = "";
    }

    /**
     * 
     * @param {*} message 
     * @param {{ status: "success" | "warning" | "error" | "progress", retry: Function, title: string }} param1 
     */
    alert(message, { title = "", status = "success", retry } = {}) {
        this.title = title;
        this.message = message;
        this.status = status;
        this.active = true;
        this.retry = retry;
        this.conductor.notify();
    }

    close() {
        this.title = "";
        this.message = "";
        this.status = "";
        this.active = false;
        this.retry = null;
        this.conductor.notify();
    }
}